// Simple timeago function
function timeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const isToday = date.toDateString() === now.toDateString();
  const isYesterday = date.toDateString() === new Date(now - 24 * 60 * 60 * 1000).toDateString();

  if (isToday) {
    if (hours < 16) {
      if (hours > 0) return hours + (hours === 1 ? ' hour ago' : ' hours ago');
      if (minutes > 0) return minutes + (minutes === 1 ? ' minute ago' : ' minutes ago');
      return 'Now';
    } else {
      return 'Today';
    }
  } else if (isYesterday) {
    return 'Yesterday';
  } else {
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
}

// Initialize timeago for all elements with class "timeago"
document.addEventListener('DOMContentLoaded', () => {
  const timeElements = document.querySelectorAll('time.timeago');
  timeElements.forEach(elem => {
    const datetime = elem.getAttribute('datetime');
    if (datetime) {
      elem.textContent = timeAgo(datetime);
    }
  });
}); 